__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) { return typeof console !== "undefined" && console.warn && console.warn(msg); };
	var uniqueName = "elta-md";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@radix-ui/react-toast", "1.0.0", function() { return Promise.all([__webpack_require__.e(216), __webpack_require__.e(900), __webpack_require__.e(830), __webpack_require__.e(352)]).then(function() { return function() { return __webpack_require__(8216); }; }); });
			register("axios", "0.27.2", function() { return __webpack_require__.e(803).then(function() { return function() { return __webpack_require__(5803); }; }); });
			register("react-dom", "18.2.0", function() { return Promise.all([__webpack_require__.e(749), __webpack_require__.e(900)]).then(function() { return function() { return __webpack_require__(5749); }; }); });
			register("react-router-dom", "6.3.0", function() { return Promise.all([__webpack_require__.e(776), __webpack_require__.e(900), __webpack_require__.e(710)]).then(function() { return function() { return __webpack_require__(3776); }; }); });
			register("react", "18.2.0", function() { return __webpack_require__.e(969).then(function() { return function() { return __webpack_require__(969); }; }); });
			register("ui", "0.0.0", function() { return Promise.all([__webpack_require__.e(530), __webpack_require__.e(900), __webpack_require__.e(830), __webpack_require__.e(119), __webpack_require__.e(684)]).then(function() { return function() { return __webpack_require__(2119); }; }); });
			register("utils", "0.0.0", function() { return Promise.all([__webpack_require__.e(900), __webpack_require__.e(290)]).then(function() { return function() { return __webpack_require__(6290); }; }); });
			register("web-vitals", "2.1.4", function() { return __webpack_require__.e(415).then(function() { return function() { return __webpack_require__(5415); }; }); });
			initExternal(9444);
			initExternal(8236);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};